import { Routes, Route, Navigate } from 'react-router-dom'
import Landing from './pages/Landing'
import Calculadora from './pages/Calculadora'
import Triagem from './pages/Triagem'
import Proposta from './pages/Proposta'
import Contratacao from './pages/Contratacao'
import Ativar from './pages/Ativar'
import PortalDocumentos from './pages/PortalDocumentos'
import DashboardCliente from './pages/DashboardCliente'
import FilaCasos from './pages/interno/FilaCasos'
import Metricas from './pages/interno/Metricas'
import Producao from './pages/interno/Producao'
import CasoDetalhe from './pages/interno/CasoDetalhe'

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/calculadora" element={<Calculadora />} />
      <Route path="/triagem" element={<Triagem />} />
      <Route path="/proposta" element={<Proposta />} />
      <Route path="/contratar" element={<Contratacao />} />
      <Route path="/ativar" element={<Ativar />} />
      <Route path="/documentos" element={<PortalDocumentos />} />
      <Route path="/painel" element={<DashboardCliente />} />
      <Route path="/interno" element={<FilaCasos />} />
      <Route path="/interno/producao" element={<Producao />} />
      <Route path="/interno/caso/:id" element={<CasoDetalhe />} />
      <Route path="/interno/metricas" element={<Metricas />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
